import type { ClientWithProjects } from "@/hooks/useClientsData";
import { Link } from "@tanstack/react-router";
import { Pencil } from "lucide-react";
import { CopyButton } from "./CopyButton";

interface ClientRowProps {
  client: ClientWithProjects;
  onEdit: (client: ClientWithProjects) => void;
}

export function ClientRow({ client, onEdit }: ClientRowProps) {
  return (
    <div className="clients-table__row">
      <div className="clients-table__cell clients-table__cell--name">{client.name}</div>

      <div className="clients-table__cell clients-table__cell--projects">
        {client.projects.length > 0 ? (
          <div className="clients-table__project-links">
            {client.projects.map((project) => (
              <Link
                key={project.id}
                to="/"
                search={{ project: project.id }}
                className="clients-table__project-pill"
                title={`Open ${project.name}`}
              >
                {project.name}
              </Link>
            ))}
          </div>
        ) : (
          <span className="clients-table__muted">No projects</span>
        )}
      </div>

      <div className="clients-table__cell clients-table__cell--contact">
        {client.contact_name || client.contact_email || client.contact_phone ? (
          <>
            {client.contact_name && <span>{client.contact_name}</span>}
            {client.contact_email && (
              <span className="clients-table__contact-line">
                <a href={`mailto:${client.contact_email}`} className="clients-table__link">
                  {client.contact_email}
                </a>
                <CopyButton value={client.contact_email} label="Copy email" />
              </span>
            )}
            {client.contact_phone && (
              <span className="clients-table__contact-line">
                <span className="clients-table__muted">{client.contact_phone}</span>
                <CopyButton value={client.contact_phone} label="Copy phone number" />
              </span>
            )}
          </>
        ) : (
          "—"
        )}
      </div>

      <div className="clients-table__cell">{client.location || "—"}</div>

      <div className="clients-table__cell clients-table__cell--actions">
        <button
          type="button"
          className="board-controls__icon-button"
          onClick={() => onEdit(client)}
          title="Edit client"
          aria-label={`Edit ${client.name}`}
        >
          <Pencil size={16} />
        </button>
      </div>
    </div>
  );
}
